import React, { ReactNode } from "react";
import { BuildNode } from "../build/types";
import { conditionFilterFunctions } from "../build/filterChildren";

interface FilterChildrenArgs {
    children: ReactNode | ReactNode[];
    childrenFilterKey?: keyof typeof conditionFilterFunctions;
    dataObject?: any;
    previewChildIndex?: number;
    isBuilder?: boolean;
}

export default function filterChildren({
    children,
    childrenFilterKey,
    dataObject,
    previewChildIndex,
    isBuilder
}: FilterChildrenArgs): ReactNode | ReactNode[] {
  if (!childrenFilterKey || !children) return children;

    let childrenToShow: ReactNode | ReactNode[] = children;

    // Grab the filter function if any
    const childrenFilter = conditionFilterFunctions[childrenFilterKey];

    if (childrenFilter) {
        if (!Array.isArray(children)) {
            return <div>Component error: component expecting children</div>;
        }

        // Filter function returns an index
        let idxChildToShow = childrenFilter(children.map(c => (c as React.ReactElement).props) as BuildNode[], dataObject);


        // On Builder mode, previewChildIndex may override the filter’s index
        if (isBuilder && previewChildIndex !== undefined) {
            idxChildToShow = previewChildIndex;
        }

        if (typeof idxChildToShow === "number" && idxChildToShow >= 0) {
            if (idxChildToShow < children.length) {
                childrenToShow = children[idxChildToShow];
            } else {
                childrenToShow = children[0];
            }
        }
    }

    // Return the final "filtered" children
    return childrenToShow;
}
